var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "room-meeting-note-modal-component flex flex-col border border-gray-300",
    },
    [
      _c(
        "div",
        { staticClass: "h-20 px-6 border-b flex justify-between items-center" },
        [
          _c(
            "div",
            {
              staticClass: "font-bold leading-9",
              staticStyle: { "font-size": "28px", color: "#1D242A" },
            },
            [_vm._v(_vm._s(`AI ${this.$t("extendMenu.meetingNote.title")}`))]
          ),
          _c("button", { staticClass: "w-6 h-6", on: { click: _vm.onClose } }, [
            _c("img", {
              attrs: { src: require("@/assets/images/x_gray.svg") },
            }),
          ]),
        ]
      ),
      _vm.meetingNoteList.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "p-6 pb-0 flex justify-end items-center flex-wrap gap-2 relative lg:gap-3",
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn pr-3 rounded-lg flex items-center text-white text-sm font-bold",
                  staticStyle: { height: "44px" },
                  on: { click: _vm.onStartNewMeetingNote },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-center items-center pointer-events-none",
                      staticStyle: { width: "44px", height: "44px" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "24",
                          height: "24",
                          src: require("@/assets/images/meeting-note/add_white.svg"),
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    " " +
                      _vm._s(
                        this.$t("extendMenu.meetingNote.createMeetingNote")
                      ) +
                      " "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.ongoingMeetingNoteList && _vm.ongoingMeetingNoteList.length
        ? _c("div", { staticClass: "px-6 pb-10 border-b" }, [
            _c(
              "div",
              { staticClass: "mt-4" },
              [
                _c("RoomMeetingNoteList", {
                  attrs: {
                    meetingNoteList: _vm.ongoingMeetingNoteList,
                    showDate: false,
                  },
                  on: { click: _vm.onClickMeetingNote },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "flex-1 px-6 flex flex-col",
          class: {
            "pt-10":
              _vm.ongoingMeetingNoteList && _vm.ongoingMeetingNoteList.length,
          },
        },
        [
          _c("div", { staticClass: "flex items-center gap-x-2" }, [
            _vm.chuckedMeetingNoteList
              ? _c("div", { staticClass: "relative" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "h-9 rounded-lg border px-2 flex justify-between items-center relative",
                      staticStyle: {
                        width: "108px",
                        "border-color": "#C3CCD5",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showSortOption = !_vm.showSortOption
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-left text-sm font-medium",
                          staticStyle: { color: "#1D242A" },
                        },
                        [_vm._v(_vm._s(_vm.selectedSortOptionTitle))]
                      ),
                      _c("img", {
                        staticClass: "pointer-events-none",
                        attrs: {
                          src: require("@/assets/images/arrow_triangle_down.svg"),
                        },
                      }),
                    ]
                  ),
                  _vm.showSortOption
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "bg-white rounded-lg border absolute top-10 left-0 z-10 overflow-hidden",
                          staticStyle: {
                            width: "108px",
                            "border-color": "#E6EBEF",
                            "box-shadow":
                              "0px 2px 16px 0px rgba(0, 0, 0, 0.16)",
                          },
                        },
                        _vm._l(_vm.sortOptions, function (item, i) {
                          return _c(
                            "button",
                            {
                              key: i,
                              staticClass:
                                "w-full h-9 px-2 text-left text-sm font-medium",
                              class: [{ "border-t": i > 0 }],
                              staticStyle: {
                                color: "#2E3842",
                                "border-color": "#E6EBEF",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickSortButton(item.value)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.title) + " ")]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "min-w-0 flex-1 relative",
              class: {
                "mt-6":
                  _vm.chuckedMeetingNoteList &&
                  _vm.chuckedMeetingNoteList.length > 0,
              },
            },
            [
              _vm.chuckedMeetingNoteList &&
              _vm.chuckedMeetingNoteList.length > 0
                ? _c("perfect-scrollbar", { staticClass: "absolute inset-0" }, [
                    _c(
                      "div",
                      { staticClass: "space-y-10 pb-10" },
                      _vm._l(
                        _vm.chuckedMeetingNoteList,
                        function (meetingNoteList) {
                          return _c("RoomMeetingNoteList", {
                            key: meetingNoteList[0]?.meetingNoteId,
                            attrs: { meetingNoteList: meetingNoteList },
                            on: { click: _vm.onClickMeetingNote },
                          })
                        }
                      ),
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.meetingNoteList.length < 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "h-full flex flex-col justify-center items-center gap-y-10",
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "300px", height: "300px" } },
                        [
                          _c("GrmIcon", {
                            attrs: { icon: "meeting-note-init", size: "full" },
                          }),
                        ],
                        1
                      ),
                      _c("p", {
                        staticClass: "text-center text-lg leading-7",
                        staticStyle: { color: "#4A5A69" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("extendMenu.meetingNote.ai.description")
                          ),
                        },
                      }),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn pr-4 rounded-lg flex items-center gap-x-1 text-white font-bold",
                          staticStyle: { height: "52px" },
                          on: { click: _vm.onStartNewMeetingNote },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex justify-center items-center pointer-events-none",
                              staticStyle: { width: "50px", height: "50px" },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "28",
                                  height: "28",
                                  src: require("@/assets/images/meeting-note/add_white.svg"),
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("extendMenu.meetingNote.newMeetingNote")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isOpenNoteDetail
            ? _c("RoomMeetingNoteDetail", {
                staticClass: "slide-right",
                attrs: { meetingNote: _vm.selectedNote },
                on: { goBack: _vm.onClickGoBack, close: _vm.onClose },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }